module.exports = __webpack_public_path__ + "static/img/Webinar 2020-04-07.79a88e1.png";